module.exports = __webpack_public_path__ + "media/images/emoticons/emoticons-6e40f7b3f76187e8ec64fc032286c091.gif";